class Video {
  constructor(config = {}) {
    const {
      video
    } = config;
    const thumbnail = Array.prototype.slice.call(document.querySelectorAll(video));
    thumbnail.forEach(image =>{
      image.addEventListener('click', () => {
        const video = image.parentElement;
        const button = video.querySelector('button');
        const iframe = video.querySelector('iframe');
        if(iframe.src && iframe.src.includes('?')){
          iframe.src = iframe.src + '&autoplay=1';
        } else {
          iframe.src = iframe.src + '?autoplay=1';
        }
        button.classList.add('fade-out');
        image.classList.add('fade-out');
        button.style.display = 'none';
        image.style.display = 'none';
      });
    });
  }
} export default Video;
